var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.listOfWays,"item-text":"title","item-value":"id","label":"Спосіб списання","return-object":"","hide-details":"","dense":"","menu-props":{
    nudgeRight: 30,
    transition: 'scale-transition',
    offsetY: ''
  },"outlined":""},on:{"input":_vm.selectWay},model:{value:(_vm.selectedWay),callback:function ($$v) {_vm.selectedWay=$$v},expression:"selectedWay"}})}
var staticRenderFns = []

export { render, staticRenderFns }